"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureI18n = exports.translate = void 0;
const i18n_js_1 = __importDefault(require("i18n-js"));
const lodash_memoize_1 = __importDefault(require("lodash.memoize"));
const languages_1 = require("./languages");
// fallback if no available language fits
const fallbackLocale = { languageTag: 'en-US', isRTL: false };
/**
 * Use i18n.t
 * Translations are cached for better performance
 * https://github.com/fnando/i18n-js#setting-up
 * @param key translation key eg: button.logout
 * @param data key value pair for interpolation
 */
exports.translate = (0, lodash_memoize_1.default)((key, config) => i18n_js_1.default.t(key, config), (key, config) => config ? key + JSON.stringify(config) : key);
/**
 * Configures i18n package with specified locale
 * Fallbacks to en-US locale if specified locale is not found
 * @param preferredLocale
 */
function configureI18n(preferredLocale) {
    let languageTag = preferredLocale || fallbackLocale.languageTag;
    // if unsupported locale is passed, fallback
    if (languages_1.supportedLocales[preferredLocale] === undefined) {
        languageTag = fallbackLocale.languageTag;
    }
    // clear translation cache
    if (exports.translate.cache && typeof exports.translate.cache.clear === 'function') {
        exports.translate.cache.clear();
    }
    // set i18n-js config
    i18n_js_1.default.translations = {
        [languageTag]: languages_1.supportedLocales[languageTag].getter(),
    };
    i18n_js_1.default.locale = languageTag;
}
exports.configureI18n = configureI18n;
//# sourceMappingURL=i18n.js.map